import {
  subscriptionTypeToPlanTypeMap,
  type UserPlanType,
} from '../useUserSubscription.types';
import { type UserSubscriptionType } from '../../../services';

export const getUserPlanType = (
  plan?: UserSubscriptionType,
): UserPlanType | undefined => {
  const userPlanType = plan && subscriptionTypeToPlanTypeMap[plan];
  return userPlanType;
};
